import { render, staticRenderFns } from "./totalAccounts.vue?vue&type=template&id=5439984c"
import script from "./totalAccounts.vue?vue&type=script&lang=js"
export * from "./totalAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports